import { Button, Dialog } from '@effizency/efz-design-system';

import IntlMessages from 'components/util/IntlMessages';

interface PopUpErrorDeviceProps {
    setShowErrorDevice: (value: any) => void;
    title: string;
    content: string;
}

const PopUpErrorDevice = ({ setShowErrorDevice, title, content }: PopUpErrorDeviceProps) => {
    const clickHandler = () => {
        setShowErrorDevice(null);
    };

    return (
        <Dialog
            dataTestId="pop-up-error-device"
            title={<IntlMessages id={title} />}
            open
            onClose={clickHandler}
            primaryButton={
                <Button onClick={clickHandler} dataTestId="close-popup">
                    <IntlMessages id="label.close" />
                </Button>
            }
        >
            <p>
                <IntlMessages id={content} />
            </p>
        </Dialog>
    );
};

export default PopUpErrorDevice;
